import {
  ChangeDetectorRef,
  Component,
  OnDestroy,
  OnInit,
  TemplateRef,
  ViewChild,
} from '@angular/core';
import { FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SvgIconComponent } from 'angular-svg-icon';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzDatePickerModule } from 'ng-zorro-antd/date-picker';
import {
  NzFormControlComponent,
  NzFormItemComponent,
  NzFormModule,
} from 'ng-zorro-antd/form';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzInputModule } from 'ng-zorro-antd/input';
import { NzRadioModule } from 'ng-zorro-antd/radio';
import { NzSelectModule } from 'ng-zorro-antd/select';
import { NzToolTipModule } from 'ng-zorro-antd/tooltip';
import {
  finalize,
  firstValueFrom,
  Observable,
  Subject,
  take,
  takeUntil,
} from 'rxjs';
import { LookupItem } from '../../../../core/models/lookup.models';
import { CommonService } from '../../../../shared/services/common.service';
import {
  ApiResponses,
  BipTemplateListModel,
  CaseDetailModel,
  EditCaseDrawerParams,
  CreateBipModel,
} from '../../insights.interface';
import { InsightsService } from '../../insights.service';
import { NzAutocompleteModule } from 'ng-zorro-antd/auto-complete';
import { CommonModule } from '@angular/common';
import { DrawerService } from '../../../../core/services/drawer.service';
import { DRAWER_IDS } from '../../../../core/constants/drawer-ids.constant';
import { differenceInCalendarDays, format } from 'date-fns';
import { OrganizationService } from '../../../organizations/organization.service';
import { LoaderService } from '../../../../core/services/loader.service';
import { NzSpinModule } from 'ng-zorro-antd/spin';
import { InsightMode } from '../../insights.enums';
import {
  OrgSchedules,
  ScheduleTemplate,
} from '../../../manage-settings/manage-settings.interface';
import { CustomTimeService } from '../../../manage-settings/custom-time/custom-time.service';
import { AuthService } from '../../../../core/services/auth.service';
import {
  OrganizationDetailModel,
  userDetailModel,
} from '../../../organizations/organization.interface';
import { LabelKey } from '../../../../core/models/report-labels.model';
import { ReportLabelsService } from '../../../manage-settings/report-labels/report-labels.service';
import { ReportLabelPipe } from '../../../../core/pipes/report-label.pipe';
import { NzModalModule } from 'ng-zorro-antd/modal';
import { ApiResponse } from '../../../../core/models/api-response.models';
import { AuditContextService } from '../../../audit-logs/audit-context.service';
import { DefineBehaviorComponent } from '../view-bip-case/define-behavior/define-behavior.component';
import { NzBreadCrumbModule } from 'ng-zorro-antd/breadcrumb';
import { NzCheckboxModule } from 'ng-zorro-antd/checkbox';
import { ViewBipDrawerNavigationService } from '../view-bip-case/shared/view-bip-drawer-navigation.service';
import { OrganizationSelectionService } from '../../../../core/services/organization-selection.service';

@Component({
  selector: 'app-create-bip-case',
  standalone: true,
  imports: [
    CommonModule,
    NzFormModule,
    NzFormItemComponent,
    NzFormItemComponent,
    NzFormControlComponent,
    NzInputModule,
    NzIconModule,
    NzSelectModule,
    NzDatePickerModule,
    NzButtonModule,
    SvgIconComponent,
    NzRadioModule,
    ReactiveFormsModule,
    FormsModule,
    NzAutocompleteModule,
    NzIconModule,
    NzSpinModule,
    ReportLabelPipe,
    NzModalModule,
    NzBreadCrumbModule,
    NzCheckboxModule,
    NzToolTipModule,
  ],
  templateUrl: './create-bip-case.component.html',
})
export class CreateBipCaseComponent implements OnInit, OnDestroy {
  @ViewChild('drawerBehaviorTitleTpl')
  drawerBehaviorTitleTpl!: TemplateRef<void>;
  bipForm: FormGroup = {} as FormGroup;
  genderList: LookupItem[] = [];
  raceList: LookupItem[] = [];
  specialEducationList: LookupItem[] = [];
  languageLevelList: LookupItem[] = [];
  organizationList: LookupItem[] = [];
  generalEducationList: LookupItem[] = [];
  bipTemplateList: BipTemplateListModel[] = [];
  customScheduleList: ScheduleTemplate[] = [];
  selectedOrg: number | null = null;
  caseParams: EditCaseDrawerParams = {
    case: {} as CaseDetailModel,
    mode: InsightMode.CREATE,
  };
  loading$: Observable<boolean>;
  loading = false;
  today = new Date();
  disabledDate = (current: Date): boolean =>
    differenceInCalendarDays(current, this.today) > 0;
  caseData: CreateBipModel | null = null;
  isInitialOrgLoad = true;
  orgData: OrganizationDetailModel | null = null;
  orgId: number | null = null;
  parentOrgId: number | null = null;
  userData: userDetailModel | null = null;
  private readonly destroy$ = new Subject<void>();
  isOrganizationSearchLoading = false;
  isBipTemplateLoading = false;
  isScheduleLoading = false;
  needSafetyPlanLabel: string = LabelKey.NEEDS_SAFETY_PLAN;
  bipLable: string = LabelKey.BIP;
  isTrainingWarningVisible = false;
  previousTrainingValue = false;
  lastTrainingValue: boolean | null = null;
  IsIncludeDefaultSchedule = true;
  caseDetail: CaseDetailModel | null = null;

  constructor(
    private readonly insightsService: InsightsService,
    private readonly commonService: CommonService,
    private readonly cd: ChangeDetectorRef,
    private readonly drawerService: DrawerService,
    private readonly orgService: OrganizationService,
    private readonly loaderService: LoaderService,
    private readonly scheduleService: CustomTimeService,
    private readonly authService: AuthService,
    private readonly reportLabelsService: ReportLabelsService,
    private readonly auditContextService: AuditContextService,
    private readonly viewBipDrawerNavigationService: ViewBipDrawerNavigationService,
    private readonly orgSelectionService: OrganizationSelectionService
  ) {
    this.reportLabelsService
      .getLabelValue(LabelKey.NEEDS_SAFETY_PLAN)
      .pipe(takeUntil(this.destroy$))
      .subscribe(value => {
        this.needSafetyPlanLabel = value;
      });
    this.reportLabelsService
      .getLabelValue(LabelKey.BIP)
      .pipe(takeUntil(this.destroy$))
      .subscribe(value => {
        this.bipLable = value;
      });
    this.authService.orgData$.pipe(takeUntil(this.destroy$)).subscribe(res => {
      this.orgData = res;
      this.orgId = this.orgData?.organizationId || 0;
    });
    this.authService.userData$.pipe(takeUntil(this.destroy$)).subscribe(res => {
      this.userData = res;
    });
    this.orgSelectionService.parentOrgId$
      .pipe(takeUntil(this.destroy$))
      .subscribe(parentOrgId => {
        this.parentOrgId = parentOrgId;
      });
    this.setupDrawerSubscription();
    this.loading$ = this.loaderService.loading$;
  }

  ngOnInit(): void {
    this.bipForm = this.insightsService.bipForm(
      this.caseData ?? null,
      ['caseBehaviorId', 'caseBehaviorsType', 'caseOwnerId'],
      this.isEditMode
    );
    this.insightsService.bindStudentIdExistsValidation(
      this.bipForm.get('studentId'),
      this.destroy$,
      this.isEditMode
    );
    this.lastTrainingValue =
      this.bipForm.get('isTrainingStudent')?.value === true;
    this.getMasterData();

    this.bipForm
      .get('studentId')
      ?.valueChanges.pipe(takeUntil(this.destroy$))
      .subscribe(newStudentId => {
        if (newStudentId) {
          const currentFormValues = this.bipForm.getRawValue();
          const preservedValues = {
            specialEducations: currentFormValues.specialEducations,
            generalEducations: currentFormValues.generalEducations,
            languageLevelId: currentFormValues.languageLevelId,
            note: currentFormValues.note,
            isTrainingStudent: currentFormValues.isTrainingStudent,
            isEnabledSafetyPlan: currentFormValues.isEnabledSafetyPlan,
            bipTemplateId: currentFormValues.bipTemplateId,
            customScheduleId: currentFormValues.customScheduleId,
          };

          setTimeout(() => {
            if (this.bipForm) {
              for (const key of Object.keys(preservedValues)) {
                if (
                  preservedValues[key as keyof typeof preservedValues] !==
                    undefined &&
                  preservedValues[key as keyof typeof preservedValues] !== null
                ) {
                  this.bipForm
                    .get(key)
                    ?.setValue(
                      preservedValues[key as keyof typeof preservedValues]
                    );
                }
              }
            }
          });
        }
      });

    this.bipForm.controls['organizationId'].valueChanges
      .pipe(takeUntil(this.destroy$))
      .subscribe((val: string) => {
        if (val) {
          this.bipForm.controls['bipTemplateId'].enable();
          this.bipForm.controls['customScheduleId'].enable();
        } else {
          this.bipForm.controls['bipTemplateId'].setValue(null);
          this.bipForm.controls['bipTemplateId'].disable();
          this.bipForm.controls['customScheduleId'].setValue(null);
          this.bipForm.controls['customScheduleId'].disable();
        }

        if (val && Number(val) !== this.selectedOrg && !this.isInitialOrgLoad) {
          this.selectedOrg = Number(val);
          this.bipTemplateList = [];
          this.customScheduleList = [];
          this.getBipTemplates(this.selectedOrg);
          this.getCustomSchedules(Number(val));

          this.bipForm.controls['bipTemplateId'].setValue(null);
          this.bipForm.controls['customScheduleId'].setValue(null);
        } else if (
          val &&
          Number(val) !== this.selectedOrg &&
          this.isInitialOrgLoad
        ) {
          this.selectedOrg = Number(val);
          this.getBipTemplates(this.selectedOrg);
          this.getCustomSchedules(Number(val));
          this.isInitialOrgLoad = false;
        }
      });
  }

  private setupDrawerSubscription(): void {
    this.drawerService
      .getParams<EditCaseDrawerParams>(DRAWER_IDS.BIP)
      .pipe(takeUntil(this.destroy$))
      .subscribe(params => {
        if (params) {
          this.caseParams = params;
          if (this.caseParams) {
            this.caseData = {
              dateOfBirth: this.caseParams?.case?.student.dateOfBirth || '',
              studentId: this.caseParams?.case?.student.enrollId || '',
              firstName: this.caseParams?.case?.student.firstName || '',
              genderId: Number(this.caseParams?.case?.student.genderId),
              lastName: this.caseParams?.case?.student.lastName || '',
              customScheduleId: Number(
                this.caseParams?.case?.student?.customScheduleId
              ),
              organizationId: Number(
                this.caseParams?.case?.student.organizationId
              ),
              raceId: Number(this.caseParams?.case?.student.raceId),
              bipTemplateId: Number(this.caseParams?.case?.bipTemplateId),
              generalEducations:
                this.caseParams?.case?.generalEducations.map(g => {
                  return g.generalEducationId;
                }) || [],
              isEnabledSafetyPlan:
                this.caseParams?.case?.isEnabledSafetyPlan || false,
              isTrainingStudent:
                this.caseParams?.case?.isTrainingStudent || false,
              languageLevelId: Number(this.caseParams?.case?.languageLevelId),
              note: this.caseParams?.case?.note || '',
              specialEducations:
                this.caseParams?.case?.specialEducations.map(g => {
                  return g.specialEducationId;
                }) || [],
            };
            this.selectedOrg = this.caseData.organizationId;
            this.isInitialOrgLoad = true;

            if (this.caseParams.mode === InsightMode.EDIT) {
              this.getBipTemplates(this.caseData.organizationId);
              this.getCustomSchedules(this.caseData.organizationId);
            }
          }
        }
      });
  }

  get isEditMode(): boolean {
    return this.caseParams.mode === InsightMode.EDIT;
  }
  private getMasterData(): void {
    this.loaderService.show();
    Promise.all([
      firstValueFrom(this.commonService.getDataByType('gender')),
      firstValueFrom(this.commonService.getDataByType('races')),
      firstValueFrom(this.commonService.getDataByType('SpecialEducation')),
      firstValueFrom(this.commonService.getDataByType('generalEducation')),
      firstValueFrom(this.commonService.getDataByType('LanguageLevels')),
      this.userData?.isSuperAdmin
        ? firstValueFrom(this.commonService.getDataByType('Organization', ''))
        : (this.getAllOrganization(),
          Promise.resolve(undefined as ApiResponses<LookupItem> | undefined)),
    ])
      .then(
        ([
          genderList,
          raceList,
          specialEducationList,
          generalEducationList,
          languageLevelList,
          organizationList,
        ]: [
          ApiResponses<LookupItem> | undefined,
          ApiResponses<LookupItem> | undefined,
          ApiResponses<LookupItem> | undefined,
          ApiResponses<LookupItem> | undefined,
          ApiResponses<LookupItem> | undefined,
          ApiResponses<LookupItem> | undefined,
        ]) => {
          this.genderList = genderList ? genderList.result : [];
          this.raceList = raceList ? raceList.result : [];
          this.specialEducationList = specialEducationList
            ? specialEducationList.result
            : [];
          this.generalEducationList = generalEducationList
            ? generalEducationList.result
            : [];
          this.languageLevelList = languageLevelList
            ? languageLevelList.result
            : [];
          this.organizationList = organizationList
            ? organizationList.result
            : [];

          if (
            this.caseParams.mode === InsightMode.EDIT &&
            this.caseData?.organizationId
          ) {
            this.bipForm.controls['organizationId'].setValue(
              this.caseData.organizationId
            );
            this.bipForm.controls['organizationId'].disable();
          } else {
            this.bipForm.controls['organizationId'].setValue(null);
            this.bipForm.controls['organizationId'].enable();
          }

          const selectedOrgId = this.bipForm.controls['organizationId'].value;
          this.orgId = selectedOrgId ? Number(selectedOrgId) : null;
          if (selectedOrgId) {
            this.getBipTemplates(Number(selectedOrgId));
            this.getCustomSchedules(Number(selectedOrgId));
          }
          if (this.caseData) {
            const isOrgAvailable = this.organizationList.some(
              org => org.id === this.caseData?.organizationId
            );
            if (!isOrgAvailable) {
              this.getMissingOrganization(this.caseData.organizationId);
            }
          }
        }
      )
      .catch(e => console.error(e))
      .finally(() => this.loaderService.hide());
  }

  getBipTemplates(orgId: number) {
    this.isBipTemplateLoading = true;
    const caseId = this.caseParams?.case?.id ?? null;
    this.insightsService
      .getBipTemplates(orgId ?? 0, true, caseId, this.isEditMode)
      .pipe(
        takeUntil(this.destroy$),
        finalize(() => {
          this.bipForm.controls['bipTemplateId'].enable();
          this.isBipTemplateLoading = false;
        })
      )
      .subscribe({
        next: (res: ApiResponses<BipTemplateListModel>) => {
          this.bipTemplateList = res.result;
          if (!this.bipForm.controls['bipTemplateId'].value) {
            const defaultTemplate = this.bipTemplateList.find(
              template => template.isDefault
            );
            if (defaultTemplate) {
              this.bipForm.controls['bipTemplateId'].setValue(
                defaultTemplate.id
              );
            }
          }
        },
        error: (error: Error) => {
          this.commonService.notify('error', error.message);
        },
      });
  }

  getCustomSchedules(orgId: number) {
    this.isScheduleLoading = true;
    this.scheduleService
      .getAssignedScheduleListByOrgId(orgId, this.IsIncludeDefaultSchedule)
      .pipe(
        takeUntil(this.destroy$),
        finalize(() => {
          this.bipForm.controls['customScheduleId'].enable();
          this.isScheduleLoading = false;
        })
      )
      .subscribe({
        next: (res: OrgSchedules[]) => {
          const orgCustomScheduleList = res;
          const scheduleforSelectedOrg = orgCustomScheduleList.find(
            schedule =>
              schedule.organizationId ===
              this.bipForm.controls['organizationId'].value
          );
          this.customScheduleList =
            scheduleforSelectedOrg?.scheduleTemplates || [];
          if (scheduleforSelectedOrg) {
            const defaultSchedule =
              scheduleforSelectedOrg.scheduleTemplates.find(
                schedule => schedule.isDefault
              );
            if (defaultSchedule) {
              this.bipForm.controls['customScheduleId'].setValue(
                defaultSchedule.customScheduleId
              );
            }
          }
        },
        error: (error: Error) => {
          this.commonService.notify('error', error.message);
        },
      });
  }

  getMissingOrganization(orgId: number) {
    this.orgService
      .getOrganization(orgId)
      .pipe(takeUntil(this.destroy$))
      .subscribe(res => {
        if (!!res && !!res.id) {
          this.organizationList.push({
            id: res.id,
            value: res.organizationName,
          });
        }
      });
  }

  onSearchOrganization(value: string) {
    this.isOrganizationSearchLoading = true;
    if (this.userData?.isSuperAdmin) {
      this.commonService
        .getDataByType('Organization', value)
        .pipe(
          takeUntil(this.destroy$),
          finalize(() => {
            this.isOrganizationSearchLoading = false;
          })
        )
        .subscribe(orgList => {
          this.organizationList = orgList.result;
        });
    } else {
      this.getAllOrganization();
      this.isOrganizationSearchLoading = false;
    }
  }

  getAllOrganization() {
    this.commonService.orgList$
      .pipe(takeUntil(this.destroy$))
      .subscribe(orgs => {
        this.organizationList = orgs;
      });
  }

  onSubmit(isPreview = false) {
    if (this.bipForm.invalid) {
      for (const key of Object.keys(this.bipForm.controls)) {
        this.bipForm.controls[key].markAsDirty();
        this.bipForm.controls[key].updateValueAndValidity();
      }
      return;
    }
    const form = this.bipForm.getRawValue();
    const data = {
      ...form,
      dateOfBirth: format(
        this.bipForm.controls['dateOfBirth'].value,
        'yyyy-MM-dd'
      ),
    };

    const original = this.caseData || {};
    const labelMap: Record<string, string> = {
      studentId: 'Student ID',
      organizationId: 'Organization',
      firstName: 'First Name',
      lastName: 'Last Name',
      genderId: 'Gender',
      dateOfBirth: 'Date of Birth',
      raceId: 'Race',
      languageLevelId: 'Language Level',
      note: 'Note',
      isTrainingStudent: 'Training Student',
      isEnabledSafetyPlan: 'Safety Plan Enabled',
      specialEducations: 'Special Educations',
      generalEducations: 'General Educations',
      bipTemplateId: 'BIP Template',
      customScheduleId: 'Custom Schedule',
    };

    const sensitiveFields: string[] = [];
    const excludeFields = ['caseOwnerId'];

    // Helper to enrich a data object with display values for audit log comparison
    const enrichData = (src: Partial<CreateBipModel>) => ({
      ...src,
      genderName: this.genderList.find(g => g.id === src.genderId)?.value || '',
      raceName: this.raceList.find(r => r.id === src.raceId)?.value || '',
      organizationName:
        this.organizationList.find(o => o.id === src.organizationId)?.value ||
        '',
      customScheduleName:
        this.customScheduleList.find(
          s => s.customScheduleId === src.customScheduleId
        )?.templateName || '',
      bipTemplateName:
        this.bipTemplateList.find(b => b.id === src.bipTemplateId)
          ?.templateName || '',
      languageLevelName:
        this.languageLevelList.find(l => l.id === src.languageLevelId)?.value ||
        '',
      specialEducationsName: (src.specialEducations || [])
        .map(
          (id: number) =>
            this.specialEducationList.find(s => s.id === id)?.value || ''
        )
        .filter(Boolean)
        .join(', '),
      generalEducationsName: (src.generalEducations || [])
        .map(
          (id: number) =>
            this.generalEducationList.find(g => g.id === id)?.value || ''
        )
        .filter(Boolean)
        .join(', '),
    });

    const enrichedData = enrichData(data);
    const originalEnriched = enrichData(original);

    const enrichedLabelMap = {
      ...labelMap,
      genderName: 'Gender',
      raceName: 'Race',
      organizationName: 'Organization',
      customScheduleName: 'Custom Schedule',
      bipTemplateName: 'BIP Template',
      languageLevelName: 'Language Level',
      specialEducationsName: 'Special Educations',
      generalEducationsName: 'General Educations',
    };

    const enrichedExcludeFields = [
      ...excludeFields,
      'genderId',
      'raceId',
      'organizationId',
      'customScheduleId',
      'bipTemplateId',
      'languageLevelId',
      'specialEducations',
      'generalEducations',
    ];

    const _modifiedFields = this.auditContextService.buildFieldChanges(
      originalEnriched,
      enrichedData,
      {
        sensitiveFields,
        labelMap: enrichedLabelMap,
        excludeFields: enrichedExcludeFields,
      }
    );

    const payload = { ...data, _modifiedFields };

    this.loading = true;
    const operation$: Observable<
      ApiResponse<number> | ApiResponse<CaseDetailModel>
    > =
      !!this.caseParams.case && this.caseParams.mode === InsightMode.EDIT
        ? this.insightsService.editBipCase(
            payload,
            Number(this?.caseParams?.case?.id)
          )
        : this.insightsService.createBipCase(payload);

    operation$
      .pipe(
        take(1),
        takeUntil(this.destroy$),
        finalize(() => {
          this.loading = false;
        })
      )
      .subscribe({
        next: (res: ApiResponse<number> | ApiResponse<CaseDetailModel>) => {
          this.handleSubmissionSuccess();
          if (isPreview || this.isEditMode) {
            this.loading = false;
            this.openViewDrawer(
              !!this.caseParams.case &&
                this.caseParams.mode === InsightMode.EDIT
                ? (res.result as CaseDetailModel)?.id
                : (res.result as number)
            );
          } else {
            this.closeDrawer();
          }
        },
        error: (error: Error) => {
          this.loading = false;
          this.handleError(error);
          this.cd.markForCheck();
        },
      });
  }

  private handleSubmissionSuccess(): void {
    this.showNotification();
  }

  openViewDrawer(caseId: number): void {
    this.insightsService
      .getCaseById(caseId)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (response: ApiResponse<CaseDetailModel>) => {
          this.caseDetail = response.result;
          // Swapped from opening Define Behavior directly to opening the case details view.
          // this.drawerService.closeDrawer(DRAWER_IDS.BIP);
          // this.openDefineBehaviorDrawer();
          this.viewBipDrawerNavigationService.openFromCaseDetail(
            this.caseDetail,
            [DRAWER_IDS.BIP]
          );
        },
        error: (error: Error) => {
          this.commonService.notify('error', error.message);
        },
      });
  }
  closeBehaviorDrawer() {
    this.drawerService.closeDrawer(DRAWER_IDS.DEFINE_BEHAVIOR);
  }
  openDefineBehaviorDrawer(): void {
    this.drawerService.openDrawer(
      DefineBehaviorComponent,
      this.drawerBehaviorTitleTpl as unknown as TemplateRef<object>,
      1170,
      true,
      undefined,
      {
        case: this.caseDetail,
        mode: InsightMode.ADD_BEHAVIOR,
      },
      DRAWER_IDS.DEFINE_BEHAVIOR
    );
  }
  private getBipLabel(): string {
    return this.bipLable ? this.bipLable : 'Behavior Intervention Plan';
  }

  private showNotification(): void {
    const bipLabel = this.getBipLabel();
    const message =
      this.caseParams.mode === InsightMode.EDIT
        ? `${bipLabel} has been updated successfully`
        : `${bipLabel} has been created successfully`;

    this.commonService.notify('success', message, '', '450px');
  }

  private handleError(error: Error): void {
    this.loading = false;

    this.commonService.notify('error', error.message);
  }

  closeDrawer() {
    this.drawerService.closeDrawer(DRAWER_IDS.BIP_DETAIL);
    this.drawerService.closeDrawer(DRAWER_IDS.BIP);
  }

  onTrainingStudentChange(value: boolean): void {
    if (value === true && this.lastTrainingValue !== true) {
      this.isTrainingWarningVisible = true;
    }

    this.lastTrainingValue = value;
  }

  handleCancelTrainingWarning(): void {
    this.isTrainingWarningVisible = false;
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
